/*
 * The parts of a message an ops user scans for: dates, batch ids, loop request
 * numbers and email addresses. Most messages on these screens are the backend's,
 * written for the ops user and shown as they come, so the screen never rewords
 * them; it only finds these parts so they can be set in bold.
 */

/* A date as the screens write it (DD-MM-YYYY) or as the backend's messages do
   (D MMM YYYY: "12 Oct 2026"). */
const DATE = /\b(?:\d{2}-\d{2}-\d{4}|\d{1,2} (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{4})\b/;

const KEY_PATTERNS = [
  DATE,
  /* A batch id: <course>-<DDMonYY>-<sessions>-<unique id> (batchName.js). */
  /[^\s,;:()]+-\d{2}[A-Z][a-z]{2}\d{2}-\d+-[A-Za-z0-9]+/,
  /* A loop request, RQ<id>. */
  /\bRQ\d+\b/,
  /* An email address; a full stop ending the sentence is not part of it. */
  /[^\s@,;:()]+@[^\s@,;:()]+\.[A-Za-z]{2,}/,
];

const keyPartsPattern = () =>
  new RegExp(KEY_PATTERNS?.map((pattern) => `(?:${pattern?.source})`)?.join("|"), "g");

/**
 * A message split into plain and key parts, in order. A key part that is a date
 * says so, since a date must not break at its hyphens.
 * @param {string} text
 * @returns {{text: string, isKey: boolean, isDate?: boolean}[]}
 */
export const emphasisPartsOf = (text) => {
  const value = typeof text === "string" ? text : "";
  const pattern = keyPartsPattern();
  const parts = [];
  let last = 0;
  let match = pattern?.exec(value);
  while (match) {
    const start = match?.index ?? 0;
    const found = match?.[0] ?? "";
    if (start > last) parts?.push({ text: value?.slice(last, start), isKey: false });
    parts?.push({ text: found, isKey: true, isDate: DATE?.test(found) });
    last = start + found?.length;
    match = pattern?.exec(value);
  }
  if (last < value?.length) parts?.push({ text: value?.slice(last), isKey: false });
  return parts;
};
